export default "__VITE_PUBLIC_ASSET__2140818c__"